export const environment = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Bogota",
  code: "CO",
  currency: "COP",
  country_code: "+57",
  gateway: {
    base_url: "https://services.rappi.com",
  },
  currencySymbol: "$",
  country: {
    defaultLocale: "es-CO",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/co/cargo-logos/",
  oAuth: {
    client_id: "C5Ej64OTPM2AV9tpBHwXRMgFB2QIJw0bbPeKDg0v",
    redirect_uri: "https://turbo-wms.rappi.com.co",
    response_type: "code",
    scope: "all",
    flowName: "GeneralOAuthFlow",
  },
  OAuthGateway: "https://www.rappi.com.co/login-legacy",
  userToken: "xxxxxxxx",
  auth0: {
    domain: "turbo-prod.us.auth0.com",
    clientId: "v1K0PlsApi2RuWQcEwdd5MJFN4XUSL8G",
    redirectUri: "https://turbo-wms.rappi.com.co",
  },
  nexusHubUrl: "https://turbo-nexus-hub.rappi.com/",
};
